// Asset CDN — bucket sends Access-Control-Allow-Origin:* (verified 2026-07-05).
// GLBs MUST load directly from here, never via a proxy (a rewrite proxy corrupted
// gzip'd GLB streams in the dashboard; lesson learned).
export const CDN_BASE = 'https://trusthub.nyc3.digitaloceanspaces.com'

// Trustup API v3, same-origin path. Dev: Vite proxy (vite.config.ts).
// Prod: Caddy reverse-proxy or the Alt-API /web read route serves the same path.
export const API_BASE = '/trustup-api'

// Full-experience CTA targets. TODO: replace with real store links when decided.
export const SITE_URL = 'https://thealternatives.app'

// Anonymous funnel beacon (Alt-API). Cross-origin by design — sent as a
// text/plain Blob so it stays a CORS "simple request" (no preflight).
// Disable per-session with ?noanalytics=1.
export const ANALYTICS_URL = 'https://progress.thealternatives.app/web/events'

// Feet → meters (camera_distance arrives in feet).
export const FT_TO_M = 0.3048
